import { BASEURL, Request, TRequestMethod } from "./request.ts";
import { Schema, type SchemaObject } from "./validation.ts";

export interface ESRProfitabilityCalculationResponse {
  "pv_hint": string,
  "pv": {
        "area": number,
        "hint": string,
        "elec_annual_savings": number,
        "elec_self_consumption": number
    },
  "savings_percentage": number,
  "monthly_possible_savings": number,
  "period_under_review_savings": number,
  "period_unter_review": number,
  "annual_energy_consumption_kwh_current": number,
  "annual_energy_consumption_kwh_planned": number,
  "energy_efficiency_class_current": number,
  "energy_efficiency_class_planned": number,
  "co2_emission_current": number,
  "co2_emission_planned": number,
  "annual_savings_on_energy_costs": number,
  "total_investment_costs": number,
  "total_beg_subsidy": number,
  "co2_tax_savings": number,
  "savings_over_lifetime": number,
  "energy_savings_percentage": number,
  "monthly_profit_loss": number,
  "annual_profit_loss": number,
  "period_under_review_energy_savings": number,
  "payback_period": number,
  "return_on_investment": number,

  "profitability_outlook":{
    "now"  : ESRProfitabilityCalculationResponse,
    "in_1_year" : ESRProfitabilityCalculationResponse,
    "in_2_years" : ESRProfitabilityCalculationResponse,
  }
}

export const ESRProfitabilityCalculationFieldsSchema : SchemaObject = {
  pv_hint: 'string',
  pv: {
      area: 'number',
      hint: 'string',
      elec_annual_savings: 'number',
      elec_self_consumption: 'number'
  },
  savings_percentage: 'number',
  monthly_possible_savings: 'number',
  period_under_review_savings: 'number',
  period_under_review: 'number',
  annual_energy_consumption_kwh_current: 'number',
  annual_energy_consumption_kwh_planned: 'number',
  energy_efficiency_class_current: 'number',
  energy_efficiency_class_planned: 'number',
  co2_emission_current: 'number',
  co2_emission_planned: 'number',
  annual_savings_on_energy_costs: 'number',
  total_investment_costs: 'number',
  total_beg_subsidy: 'number',
  co2_tax_savings: 'number',
  savings_over_lifetime: 'number',
  energy_savings_percentage: 'number',
  monthly_profit_loss: 'number',
  annual_profit_loss: 'number',
  period_under_review_energy_savings: 'number',
  payback_period: 'number',
  return_on_investment: 'number'
}

export const ESRProfitabilityCalculationResponseSchema : SchemaObject = {
  ...ESRProfitabilityCalculationFieldsSchema,
  profitability_outlook:{
    now  : {...ESRProfitabilityCalculationFieldsSchema},
    in_1_year : {...ESRProfitabilityCalculationFieldsSchema},
    in_2_years : {...ESRProfitabilityCalculationFieldsSchema}
  }
}


export class ESRProfitabilityCalculation extends Request<ESRProfitabilityCalculationResponse>{
    override method : TRequestMethod = "GET";
    override responseSchema : Schema = ESRProfitabilityCalculationResponseSchema;

    constructor (
        public sessionToken: string,
        public energyIncreaseRate: number = 0,
        public co2Price: number = 0,
        public month: number,
        public year: number,
      ){
        super();
    }

    override route() : string{
        return `${BASEURL}/profitability_calculation?&month=${this.month}&year=${this.year}&&sessionToken=${this.sessionToken}&energyIncreaseRate=${this.energyIncreaseRate}&co2Price=${this.co2Price}`;
    }
}